// import moment from 'moment';
import base64 from 'base-64';

// moment.locale('es');

// export const formatDate = date => {
//   console.warn(`
//     Hey!!!
//     DON'T USE THIS METHOD, IT USE MOMEMT THAT IS A BIIIIIIGGGG LIBRARY.
//     We have a better helper in Shared/Utils/date.js :)
//   `);
//   const d = moment(date).format('MMM D, YYYY h:mm:ss a');

//   return d
//     .charAt(0)
//     .toUpperCase()
//     .concat(d.slice(1));
// };

// export const humanDate = date => {
//   console.warn(`
//     Hey!!!
//     DON'T USE THIS METHOD, IT USE MOMEMT THAT IS A BIIIIIIGGGG LIBRARY.
//     We have a better helper in Shared/Utils/date.js :)
//   `);
//   const d = moment(date).fromNow();

//   return d
//     .charAt(0)
//     .toUpperCase()
//     .concat(d.slice(1));
// };

const format = (time, bigUnit, unit, sep) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  return `${`0${minutes}`.substr(-2)}${bigUnit}${sep}${`0${seconds}`.substr(
    -2,
  )}${unit}`;
};

export const formatTime = time => format(time, 'm', 's', ' : ');

export const courseDuration = time => format(time / 60, 'h', 'm', '  ');

export const graphCursor = (currentPage, pageSize) =>
  base64.encode(`arrayconnection:${(currentPage - 1) * pageSize - 1}`);

export const getParameterByName = (name, url) => {
  if (!url) return null;

  const paramsName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${paramsName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
